import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { HttpRequestDataProvider } from './types';

@NgModule({
  imports: [HttpClientModule],
})
export class RtHttpModule {
  public static forRoot(
    httpRequestDataProvider: HttpRequestDataProvider,
  ): ModuleWithProviders<RtHttpModule> {
    return { ngModule: RtHttpModule, providers: [httpRequestDataProvider] };
  }
}
